import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // V4.0 Sprint 4 · Perf audit — timestamp every outbound request so the
  // Performance Monitor overlay can compute rolling API latency.
  config.metadata = { startedAt: performance.now() };
  return config;
});

api.interceptors.response.use(
  (r) => {
    try {
      const dt = performance.now() - (r?.config?.metadata?.startedAt || performance.now());
      const w = window;
      w.__smin_lat = (w.__smin_lat || []).concat(dt).slice(-30);
    } catch { /* never break the response chain */ }
    return r;
  },
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register")) {
        localStorage.removeItem("smin_token");
        localStorage.removeItem("smin_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
